import classNames from 'classnames';
import { BorderlessStar } from 'components/Icons';
import Tooltip from 'components/Tooltip';
import React from 'react';
import styles from './ExperimentalFeatureDecorator.module.scss';

interface Props {
  style?: React.CSSProperties;
  tooltipStyle?: React.CSSProperties;
  className?: string;
  message?: string;
  children?: React.ReactNode;
}

const ExperimentalFeatureDecorator: React.FC<Props> = props => {
  const { children, className, message, style, tooltipStyle } = props;
  return (
    <div style={style} className={styles.container}>
      <Tooltip className={classNames(styles.star, className)} style={tooltipStyle} title={message}>
        <BorderlessStar />
      </Tooltip>
      <div className={styles.children}>{children}</div>
    </div>
  );
};

export default ExperimentalFeatureDecorator;
